'use strict';

export default class GroupSettingsOverviewCtrl {
  constructor($stateParams, LoaderSvc, GroupSvc, GrpTypeSvc, GrpRoleTypeSvc,
    GroupAuthSvc, StripeSvc) {
    var that = this;
    var groupId = $stateParams.groupId;

    // authorization
    GroupAuthSvc.validatePermission(groupId, 'groupSettings', 'I');

    // Use the Group $resource to fetch all data
    GrpTypeSvc.getDesc({groupId}).$promise.then(function(gt) {
      that.groupTypes = gt;
    });
    GroupSvc.getTimePeriods({groupId}).$promise.then(function(tp) {
      that.timePeriods = tp;
    });
    GrpRoleTypeSvc.query({groupId}).$promise.then(function(grt) {
      that.groupRoleTypes = grt;
    });
    StripeSvc.getClientId().then(function(clientId) {
      that.clientId = clientId;
    });
  }
}

GroupSettingsOverviewCtrl.$inject = [
  '$stateParams',
  'LoaderSvc',
  'GroupSvc',
  'GrpTypeSvc',
  'GrpRoleTypeSvc',
  'GroupAuthSvc',
  'StripeSvc'
];
